import { GiHamburgerMenu } from "react-icons/gi"
import { IoCloseSharp } from "react-icons/io5"
import { BiLogoFacebook } from "react-icons/bi"
import { AiOutlineInstagram } from "react-icons/ai"
import {Link} from 'react-router'
import './Navbar.css'
import {useState, useEffect} from 'react'

export default function Navbar(){
    const BASE_URL = (process.env.NODE_ENV == 'production') ?
                    'https://olea-iwpz.onrender.com' : 
                    'http://localhost:1436'    

    

    useEffect(()=>getAnnualEvents(),[])

    const [mobileInfoDropdownOpen, setMobileInfoDropdown] = useState(false)
    const [mobileMenusDropdown, setMobileMenusDropdown] = useState(false)
    const [mothersDay, setMothersDay] = useState(false)
    const [parentsWeekend, setParentsWeekend] = useState(false)
    const [commencement, setCommencement] = useState(false)
    const [oleaAnniversary, setOleaAnniversary] = useState(false)
    const [dailySpecials, setDailySpecials] = useState(true)
    const [restaurantWeeksFall,setRestaurantWeeksFall] = useState(false)

    function getAnnualEvents(){
        try{
            fetch(`${BASE_URL}/api/annual-events`)
                .then(res=>res.json())
                .then(json=>{
                    setDailySpecials(json[0].DailySpecials)
                    setMothersDay(json[0].MothersDay)
                    setParentsWeekend(json[0].ParentsWeekend)
                    setCommencement(json[0].Commencement)
                    setOleaAnniversary(json[0].OleaAnniversary)
                    setRestaurantWeeksFall(json[0].RestaurantWeeksFall)
                })
                .catch(err=>console.log(err))
        }catch(err){
            console.log(err)
        }
    }

    function showMenusDropdown(){
        document.querySelector('.menus-dropdown').style.display = 'flex'
    }

    function hideMenusDropdown(){
        document.querySelector('.menus-dropdown').style.display = 'none'
    }

    function showInfoDropdown(){
        document.querySelector('.info-ul').style.display = 'flex'
    }
    function hideInfoDropdown(){
        document.querySelector('.info-ul').style.display = 'none'
    }

    function showMobileMenu(){
        document.querySelector('.close-mobile-menu').style.display = 'block'
        document.querySelector('.hamburger-menu-icon').style.display = 'none'
        document.querySelector('.mobile-menu-ul').style.height = 'auto'
        document.querySelectorAll('.navbar-mobile li').forEach(li=>li.style.height = '50px')
    }
    function hideMobileMenu(){
        document.querySelector('.close-mobile-menu').style.display = 'none'
        document.querySelector('.hamburger-menu-icon').style.display = 'block'
        document.querySelectorAll('.navbar-mobile li').forEach(li=>li.style.height = 0)
        document.querySelector('.mobile-menu-ul').style.height = 0
        setMobileInfoDropdown(false)
        setMobileMenusDropdown(false)
    }

    return(
        <>
            <div className='navbar' style={{zIndex:'2000'}}>
                <div className='navbar-mobile-icons'>
                    <IoCloseSharp   className='close-mobile-menu'
                                    onClick={hideMobileMenu} 
                                    style={{display:'none'}} />
                    <GiHamburgerMenu    className='hamburger-menu-icon'
                                        onClick={showMobileMenu} 
                                        />
                </div>{/* .navbar-mobile-icons */}
                <span className='logo'>
                    <Link to='/'><span style={{cursor:'pointer'}}>olea</span></Link>
                </span>{/* .logo */}

                <div className='navbar-tablet' style={{display:'none',width:'500px',alignItems:'center',justifyContent:'space-between'}}>

                    <span className='tablet-logo'>
                        <Link to='/'><span style={{cursor:'pointer'}}>olea</span></Link>
                    </span>
                    
                    <span className='tablet-socials'>
                        <a href='https://www.facebook.com/oleanewhaven/' target='_blank'>
                            <BiLogoFacebook />
                        </a>&nbsp;
                        <a href='https://www.instagram.com/oleanewhaven/' target='_blank'>
                            <AiOutlineInstagram />
                        </a>
                    </span>
                </div>{/* .navbar-tablet */}
                
                <div className='navbar-menu' style={{position:'relative'}}>
                            
                    <ul className='nav-ul' style={{position:'relative',top:'0',left:'0'}}>
                        <li><Link to='/'>home</Link></li>
                        <li style={{position:'relative'}} 
                            onMouseOver={showInfoDropdown}
                            onMouseLeave={hideInfoDropdown}>info
                                <ul className='info-ul nav-info'
                                    onMouseOver={showInfoDropdown}
                                    onMouseLeave={hideInfoDropdown} 
                                    style={{display:'none',                    
                                            border:'1px solid black',
                                            padding:'10px 10px',
                                            background:'#262626',
                                            width:'max-content',
                                            flexDirection:'column',
                                            position:'absolute',
                                            left:'-20px',
                                            top:'100%'}}>
                                    <li><Link to='/info'>info</Link></li>
                                    <li><Link to='/free-parking'>free parking</Link></li>
                                    <li><Link to='/chef-bio'>chef bio</Link></li>
                                    <li><Link to='/private-parties'>private parties</Link></li>
                                </ul>
                        </li>
                        <li style={{position:'relative'}} 
                            onMouseOver={showMenusDropdown}
                            onMouseLeave={hideMenusDropdown}>
                                menus
                                <ul className='menus-dropdown' 
                                    onMouseOver={showMenusDropdown}
                                    onMouseLeave={hideMenusDropdown} 
                                    style={{display:'none',
                                            position:'absolute',
                                            top:'100%',
                                            border:'1px solid black',
                                            padding:'10px',
                                            width:'max-content',
                                            background:'#262626',
                                            flexDirection:'column',
                                            left:'-20px'}}>
                                    {mothersDay && <li><Link to='/mothers-day-menu'>mother's day {new Date().getFullYear()}</Link></li>}
                                    {commencement && <li><Link to='/commencement-menu'>comencement {new Date().getFullYear()}</Link></li>}
                                    {parentsWeekend && <li><Link to='/yale-family-weekend'>yale family weekend {new Date().getFullYear()}</Link></li>}
                                    {restaurantWeeksFall && <li><Link to='/restaurant-weeks-fall'>new haven restaurant week</Link></li>}
                                    
                                    <li><Link to='/dinner'>dinner</Link></li>
                                    {oleaAnniversary && <li><Link to='/anniversary'>{new Date().getFullYear() - 2014}yr anniversary</Link></li>}
                                    {dailySpecials && <li><Link to='/specials'>specials</Link></li>}
                                    <li><Link to='/dessert'>dessert</Link></li>
                                </ul>
                        </li>
                        <li><Link to='/press'>press</Link></li>
                        {/* <li><Link to='/giftcards'>gift cards</Link></li> */}
                        <li><Link to='/newsletter'>newsletter</Link></li>
                        <li><a href='https://www.opentable.com/booking/restref/availability?rid=151186&correlationId=0c416533-c338-499b-a076-64c7c704137f&restRef=151186' target='_blank'>reservations</a></li>
                    </ul>
                    
                </div>{/* .navbar-menu */}

                <div className='navbar-socials'>
                    <a href='https://www.facebook.com/oleanewhaven/' target='_blank'>
                        <BiLogoFacebook />
                    </a>&nbsp;
                    <a href='https://www.instagram.com/oleanewhaven/' target='_blank'>
                        <AiOutlineInstagram />
                    </a>
                </div>{/* .navbar-socials */}
            </div>{/* .navbar */}



            <hr/>



            <div className='navbar-mobile'>
                <ul className='mobile-menu-ul'>
                    <Link to='/'><li><span>home</span></li></Link>
                    <li onClick={()=>setMobileInfoDropdown(prev=>!prev)}>
                        <span>{mobileInfoDropdownOpen ? '-' : '+'} info</span>
                    </li>
                    {mobileInfoDropdownOpen && 
                        <ul className='mobile-dropdown-info'>
                            <Link to='/info'><li className='mobile-menu-dropdown'><span>info</span></li></Link>
                            <Link to='/free-parking'><li className='mobile-menu-dropdown'><span>free parking</span></li></Link>
                            <Link to='/chef-bio'><li className='mobile-menu-dropdown'><span>chef bio</span></li></Link>
                            <Link to='/private-parties'><li className='mobile-menu-dropdown'><span>private parties</span></li></Link>
                        </ul>
                    }
                    
                    <li onClick={()=>setMobileMenusDropdown(prev=>!prev)}>
                        <span>{mobileMenusDropdown ? '-' : '+'} menus</span>
                    </li>
                    {mobileMenusDropdown &&                    
                        <ul className='mobile-dropdown-menus'>
                            {mothersDay && <Link to='/mothers-day-menu'><li className='mobile-menu-dropdown'><span>mother's day {new Date().getFullYear()}</span></li></Link>}
                            {commencement && <Link to='/commencement-menu'><li className='mobile-menu-dropdown'><span>commencement {new Date().getFullYear()}</span></li></Link>}
                            {parentsWeekend && <Link to='/yale-family-weekend'><li className="mobile-menu-dropdown"><span>yale family weekend {new Date().getFullYear()}</span></li></Link>}
                            {restaurantWeeksFall && <Link to='/restaurant-weeks-fall'><li className="mobile-menu-dropdown"><span>new haven restaurant week</span></li></Link>}
                            
                            <Link to='/dinner'><li className='mobile-menu-dropdown'><span>dinner</span></li></Link>
                            {oleaAnniversary && <Link to='/anniversary'><li className='mobile-menu-dropdown'><span>{new Date().getFullYear() - 2014}yr anniversary</span></li></Link>}
                            {dailySpecials && <Link to='/specials'><li className='mobile-menu-dropdown'><span>specials</span></li></Link>}
                            <Link to='/dessert'><li className='mobile-menu-dropdown'><span>dessert</span></li></Link>
                        </ul>
                    }
                    <Link to='/press'><li><span>press</span></li></Link>
                    {/* <Link to='/giftcards'><li><span>gift cards</span></li></Link> */}
                    <Link to='/newsletter'><li><span>newsletter</span></li></Link>
                    <a href='https://www.opentable.com/booking/restref/availability?rid=151186&correlationId=0c416533-c338-499b-a076-64c7c704137f&restRef=151186' target='_blank'><li><span>reservations</span></li></a>
                </ul>
            </div>{/* .navbar-mobile */}
            
        </>
    )
}